import { colors } from '@noths/polaris-client-ribbons-design-system';
import { fontSize, pxToRem, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const quantityContainer = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: ${stack(spacing.lg)};
  margin-top: ${pxToRem(36)};

  &[data-has-error='true'] #quantity {
    border-color: ${colors.functionalRedPrimary};
    background-color: ${colors.functionalRedlight};
  }
`;

export const quantityLabel = css`
  padding-right: ${pxToRem(spacing.sm)};
`;

export const errorMessage = css`
  ${fontSize(text.xxs.SMALL)}
  text-align: left;
  margin: 0;
  width: 100%;
`;

export const quantityInput = css`
  text-align: center;
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  border-radius: ${pxToRem(10)};
  border: solid 1px ${colors.neutralLight};

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
`;
